import httpClient from '@/api/index';

export default {
    getCurrentUser: function () {
        return httpClient().get('/json/user');
    },

    doLogin: function (username, password) {
        return httpClient().post('/login', {
            username,
            password,
        });
    },

    doLogout: function () {
        return httpClient().post('/json/logout');
    },

    sendResetPasswordLink: function(params) {
        return httpClient().post('/json/send_reset_password',params);
    },

    doResetPassword: function(params) {
        return httpClient().post('/json/reset_password',params);
    },

    register: function (params) {
        return httpClient().post('/json/register', params);
    },
}
